import type { AuditTrailEntry } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { JsonTree } from '../../components/generic/JsonTree';
import { createModal, showModal } from '../../components/generic/Modal';

interface AuditTrailEntryInfoModalProps {
  entry: AuditTrailEntry;
}

export const AuditTrailEntryInfoModal = createModal<AuditTrailEntryInfoModalProps>((props) => {
  const { entry, modal } = props;
  const { visible, hide, remove } = modal;

  return (
    <ChakraV3.Dialog.Root open={visible} onOpenChange={hide} onExitComplete={remove} size='lg'>
      <ChakraV3.Dialog.Backdrop />
      <ChakraV3.Dialog.Positioner>
        <ChakraV3.Dialog.Content>
          <ChakraV3.DialogTitleSubtitle title={entry.message} />
          <ChakraV3.Dialog.Body>
            <JsonTree src={entry} collapsed={2} style={{ wordBreak: 'break-all' }} />
          </ChakraV3.Dialog.Body>
          <ChakraV3.Dialog.Footer>
            <ChakraV3.Button onClick={hide} size='sm' variant='subtle'>
              Close
            </ChakraV3.Button>
          </ChakraV3.Dialog.Footer>
        </ChakraV3.Dialog.Content>
      </ChakraV3.Dialog.Positioner>
    </ChakraV3.Dialog.Root>
  );
});

interface Props {
  entry: AuditTrailEntry;
}

export const AuditTrailEntryInfoControl = (props: Props) => {
  const { entry } = props;

  return (
    <ChakraV3.Button
      variant='outline'
      size='sm'
      onClick={() => showModal(AuditTrailEntryInfoModal, { entry })}
    >
      Details
    </ChakraV3.Button>
  );
};
